import { render, staticRenderFns } from "./Gantong.vue?vue&type=template&id=c27a094c&scoped=true"
import script from "./Gantong.vue?vue&type=script&lang=js"
export * from "./Gantong.vue?vue&type=script&lang=js"
import style0 from "./Gantong.vue?vue&type=style&index=0&id=c27a094c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c27a094c",
  null
  
)

export default component.exports